import { useRef } from "react";
import { isArrayEqual } from "../util/equal.js";
import { getLazy } from "../util/lazy.js";
export function useLazy(value, ...args) {
    const internals = (useRef().current ||= {
        value: getLazy(value, ...args),
        args,
    });
    if (!isArrayEqual(args, internals.args)) {
        internals.value = getLazy(value, ...args);
        internals.args = args;
    }
    return internals.value;
}
